import { FC } from 'react'
import {
  ButtonPay,
  Container,
  PaymentMethodsHeader,
} from './payment-methods-mobile.styled'
import { usePaymentMethodsMobile } from './use-payment-methods-mobile'
import { useTranslation } from 'react-i18next'

export const PaymentMethodsMobile: FC = () => {
  const { onStartPayment, onlyExpressPaymentMethods } = usePaymentMethodsMobile()
  const { t } = useTranslation()

  return (
    <Container show={true}>
      <PaymentMethodsHeader>{t('Choose a payment method')}</PaymentMethodsHeader>
      <div id="root-sdk"></div>
      {!onlyExpressPaymentMethods && (
        <ButtonPay onClick={onStartPayment} enableReDesign={true} >{t('Pay')}</ButtonPay>
      )}
    </Container>
  )
}
